import { Link, useParams } from "react-router-dom";
import MiniHero from "../components/hero/MiniHero";
import { CalendarDays, Mail, Phone, Scale } from "lucide-react";
import { blogs } from "./Home";

const Article = () => {
  let { id } = useParams();

  // Convert id from string to number for comparison
  const numericId = parseInt(id);

  return (
      <div>
        <MiniHero
            text={blogs.find(p => p.id === numericId)?.title || ""}
            url={"/assets/img/theme/mini4.jpg"}
        />
        <ServicesDetails blogs={blogs} id={numericId} />
      </div>
  );
};

const ServicesDetails = ({ blogs, id }) => {
  const selectedBlog = blogs.find(p => p.id === id);

  const fixHtmlForRender = (htmlContent) => {
    if (!htmlContent) return "";
    return htmlContent.replace(/className=/g, 'class=');
  };

  return (
      <div className="services-details-area py-16">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-6 justify-center">
            <div className="md:col-span-7 lg:col-span-8">
              <div className="services-details">
                <div className="img">
                  <img
                      src={selectedBlog?.url || ""}
                      alt="Blog picture"
                      className="w-full"
                  />
                </div>
                <div className="services-details-content">
                  <h3 className="text-2xl font-bold mb-4">
                    {selectedBlog?.title || ""}
                  </h3>
                  <ul className="blog-list mb-4">
                    <li
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                    >
                      <CalendarDays strokeWidth={1} />
                      <span className="text-sm">
                      {selectedBlog?.date || ""}
                    </span>
                    </li>
                  </ul>

                  <div dangerouslySetInnerHTML={{ __html: fixHtmlForRender(selectedBlog?.article) }} />
                </div>
              </div>
            </div>

            <div className="md:col-span-5 lg:col-span-4">
              <div className="side-bar">
                <RecentPosts items={blogs} />
                <Tags items={selectedBlog?.tags || []} />
                <ContactUs />
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

const RecentPosts = ({ items }) => {
  // Get the last 3 items from the array
  const recentItems = [...items].slice(-3);

  return (
      <div className="side-bar-box recent-post bg-white">
        <h3 className="title">Articles récents</h3>
        {recentItems.map((post, index) => (
            <div className="single-recent-post" key={index}>
              <div className="recent-post-img">
                <Link to={`/article/${post.id}`}>
                  <img src={post.url} alt="Recent Post" />
                </Link>
              </div>
              <div className="recent-post-content">
                <ul>
                  <li>
                    <Link to={`/article/${post.id}`}>{post.date}</Link>
                  </li>
                </ul>
                <h3>
                  <Link to={`/article/${post.id}`}>{post.title}</Link>
                </h3>
              </div>
            </div>
        ))}
      </div>
  );
};
const ContactUs = () => {
  return (
      <div className="mb-8">
        <div
            className="relative w-full"
            style={{
              backgroundImage: "url('/assets/img/theme/lawyer-xx.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "left top",
              height: "360px",
            }}
        >
          <div
              className="w-full h-full flex items-center justify-center"
              style={{ backgroundColor: "rgba(50, 58, 67, 0.8)" }}
          >
            <div className="mx-6 w-[90%]">
              <div className="border-1 border-dashed border-gray-400/30 p-8 text-white">
                <div className="mb-6">
                  <Scale className="h-10 w-10 our-red-text" />
                </div>

                <h3 className="mb-3 text-2xl font-semibold">Besoin de nous ?</h3>

                <p className="mb-8 text-sm text-gray-300">
                  Si vous avez besoin d'aide, n'hésitez pas à nous contacter.
                </p>

                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <Phone className="h-5 w-5 text-red-600" />
                    <a href={"tel:+33189715961"} className="text-sm">
                      +33 1 89 71 59 61
                    </a>
                  </div>

                  <div className="flex items-center gap-3">
                    <Mail className="h-5 w-5 text-red-600" />
                    <a
                        href={"mailto:contact@mesprocedures.fr"}
                        className="text-sm"
                    >
                      contact@mesprocedures.fr
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

const Tags = ({ items }) => {
  // Function to chunk the array into groups of 3
  const chunkArray = (array, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  // Split tags into rows of 3
  const rows = chunkArray(items, 3);

  return (
      <div className="side-bar-box tags-box cursor-pointer bg-white">
        <h3 className="title">Tags</h3>
        <div className="flex flex-col space-y-4">
          {rows.map((row, rowIndex) => (
              <div key={rowIndex} className="grid grid-cols-3 gap-1">
                {row.map((tag, index) => (
                    <div key={index} className="flex items-center justify-center relative group">
                <span
                    className="hover:bg-red-700 hover:text-white px-3 py-1 rounded text-center truncate w-full"
                    title={tag} // HTML native tooltip
                >
                  {tag}
                </span>
                      {/* Tooltip on hover */}
                      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-10">
                        {tag}
                      </div>
                    </div>
                ))}
              </div>
          ))}
        </div>
      </div>
  );
};

export default Article;